import i18n from "@/lib/i18n/i18n"

// Read at call time, so a language switch shows in the next popup.
const dragHint = () => i18n.t("maps.waypointHoverPopup.dragHint")

const escapeHtml = (text: string) =>
  text.replace(
    /[&<>"']/g,
    (char) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        char
      ] || char,
  )

// Body of the popup shown while hovering a stop marker on the route map.
// A stop with a client name shows that name with the address under it;
// without one the popup stays as it was.
export const waypointHoverPopupHtml = ({
  actionLabel,
  address,
  companyName,
  isAlertMap,
}: {
  actionLabel: string
  address?: string
  companyName?: string
  isAlertMap: boolean
}) => {
  const name = companyName?.trim()
  const addressText = address?.trim() ?? ""

  if (!name) {
    const text = isAlertMap
      ? `${actionLabel} - ${escapeHtml(addressText)}`
      : dragHint()
    return `<div class="text-xs text-gray-900 dark:text-white">${text}</div>`
  }

  const title = isAlertMap ? `${actionLabel} - ${name}` : name
  const addressLine =
    addressText && addressText !== name
      ? `<div class="text-xs text-gray-600 dark:text-gray-300">${escapeHtml(addressText)}</div>`
      : ""
  const hint = isAlertMap
    ? ""
    : `<div class="mt-1 text-[10px] text-gray-500 dark:text-gray-400">${dragHint()}</div>`

  return `<div class="text-xs font-semibold text-gray-900 dark:text-white">${escapeHtml(title)}</div>${addressLine}${hint}`
}
